import { render, staticRenderFns } from "./EN.vue?vue&type=template&id=edba9506&scoped=true"
import script from "./EN.vue?vue&type=script&setup=true&lang=js"
export * from "./EN.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EN.vue?vue&type=style&index=0&id=edba9506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_css-loader@7.1.3_@rspack+core@1.6.4_webpack_d01c569c1e49243fe86a8a8a8c1d4fe3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edba9506",
  null
  
)

export default component.exports